// Create a transport
import { createClient } from "@connectrpc/connect";
import { AdminService } from "@buf/alconostmt_services.bufbuild_es/alconost/mt/admin_pb";
import { createConnectTransport } from "@connectrpc/connect-web";

const transport = createConnectTransport({
    baseUrl: 'https://services-375925469890.us-central1.run.app',
    interceptors: [
        (next) => async (req) => {
            const token = localStorage.getItem('token');
            if (token) {
                req.header.set('Authorization', `Bearer ${token}`);
            }
            return next(req);
        }
    ]
});

const adminClient = createClient(AdminService, transport);

export const listMetrics = async ({
    pageSize = 10,
    pageNumber = 1
} = {}) => {
    try {
        const request = {
            pageSize,
            pageNumber
        };

        const response = await adminClient.listMetrics(request);
        return response;
    } catch (error) {
        console.error('Error listing metrics:', error);
        throw error;
    }
};